// extracted by mini-css-extract-plugin
module.exports = {"container":"CartButton_container__l-IBn","main":"CartButton_main__2_gYf","button":"CartButton_button__ttoTJ","image":"CartButton_image__2LWJv","badge":"CartButton_badge__3qm39"};